import { Styles } from 'react-select'
import styled from 'styled-components'

export const dropdownStyles:
    | Partial<
          Styles<
              {
                  label: string
                  value: string
              },
              false
          >
      >
    | undefined = {
    indicatorSeparator: () => ({ display: 'none' }),
    control: (styles, state) => {
        if (state.selectProps.disabledWidget) {
            return {
                ...styles,
                backgroundColor: state.isDisabled ? '#eeeeee' : '#ffffff',
                borderColor: state.isDisabled ? '#c5c5c5' : '#cccccc',
            }
        }

        return {
            ...styles,
            backgroundColor: state.isDisabled ? '#eeeeee' : '#ffffff',
            borderColor: '#e7e7e7',
        }
    },
    singleValue: (_styles, state) => {
        if (state.selectProps.disabledWidget) {
            return {
                color: state.isDisabled ? '#000000' : '#555555',
                fontWeight: state.isDisabled ? 'var(--font-weight-normal)' : 'var(--font-weight-light)',
            }
        }

        return {
            color: state.isDisabled ? '#5b5b5b' : '#555555',
        }
    },
    dropdownIndicator: (styles) => ({
        ...styles,
        color: '#000000',
    }),
}

export const SOcppSettingsHeading = styled.div`
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    margin-top: 20px;
    margin-left: 5px;
`
export const SText = styled.div`
    font-size: 16px;
    font-weight: var(--font-weight-bold);
    padding: 5px 3px;
    color: ${({ theme }) => theme.brandColors.CA_Black};
`

export const SOcppSettingsHeadingIcon = styled.span`
    margin-left: 10px;
`

export const SChargerIsOfflineMessage = styled.div`
    color: #ff0000;
    font-weight: var(--font-weight-bold);
    padding: 0px 5px 10px 5px;
    font-size: 14px;
`

export const SContainer = styled.div<{ offline?: boolean }>`
    padding: 5px;
    margin-bottom: 5px;
`

export const SFormContainer = styled.div<{ isOpen: boolean }>`
    display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
`
